import * as React from 'react';
import { Container } from 'types/Watchlist';
import { formatGTD, formatLastFreeDay } from 'utils/container-transforms';
import { Tooltip } from '@mui/material';
import { CellProps } from './types';

function formatDays(days: number) {
  if (days >= 0) {
    return `+${days}`;
  }
  return `-${Math.abs(days)}`;
}

export const LastFreeDayCell: React.FC<CellProps> = (params) => {
  const container: Container = params.row;

  const lastFreeDay = formatLastFreeDay(container);
  const GTD = formatGTD(container);

  return (
    <Tooltip title="LFD is the most recent last free day, GTD is the most recent good-thru date.">
      <div className="items-center p-2">
        <div className="flex gap-1 items-center">
          <h5 className="text-sm">LFD: {lastFreeDay?.value || '-'}</h5>
          <h6 className={`${lastFreeDay?.meta?.late ? 'text-red-900' : 'text-gray-600'} text-xs`}>
            {lastFreeDay?.meta?.delta !== undefined &&
              `(${formatDays(lastFreeDay?.meta?.delta)} days)`}
          </h6>
        </div>
        <div className="flex gap-1 items-center">
          <h5 className="text-sm">GTD: {GTD?.value || '-'}</h5>
          <h6 className={`${GTD?.meta?.late ? 'text-red-900' : 'text-gray-600'} text-xs`}>
            {GTD?.meta?.delta !== undefined && `(${formatDays(GTD?.meta?.delta)} days)`}
          </h6>
        </div>
      </div>
    </Tooltip>
  );
};
LastFreeDayCell.displayName = 'ContainerTable.LastFreeDayCell';
